$(document).ready(() => {
  $('.whole-screen-divider > p > a').addClass('button');

  $('.load-more-container .load-more-button').on('click', (event) => {
    let el = $(event.currentTarget).closest('.page-details-block');
    let numCols = el.find(`.loadable-container`).attr('data-num-cols') || '3';
    let toggleClass = el.find(`.loadable-container`).data('toggle-class') || 'hidden-sm-up';
    if(!el.find(`.loadable-container .loadable.${toggleClass}:lt(${numCols})`).length) {
      el.find(`.loadable-container .loadable`).addClass(toggleClass);
      el.find('.load-more-container .button').text('Load More');
      return;
    }
    let hiddenCols = el.find(`.loadable-container .loadable.${toggleClass}:lt(${numCols})`);
    if(hiddenCols.length) {
      hiddenCols.removeClass(toggleClass);
      if(!el.find('.loadable-container .loadable.'+toggleClass).length) {
        el.find('.load-more-container .button').text('Load Less');
      }
    }
  });

  try {
    $('.slickable').slick();
  } catch (e){}

  $('.hero .video-half .video-img').on('click', function(){
    let img = $(this);
    let iframe = $(this).next()[0];
    iframe.src += '&autoplay=1'
    setTimeout(function(){img.addClass('hidden');img.closest('.video-image-cover').removeClass('video-image-cover');}, 300);
  });

  $('.show-video-button').on('click', function(){
    let videoUrl = $(this).data('video-url');
    $('body').prepend(`<page-overlay class="see-through">
        <div>
          <div class="primary-content video-content flex-grids gutterless">
            <div class="row marginless"><div class="col-xs-12 marginless">
            <iframe src="${videoUrl}"></iframe>
            </div></div>
          </div>
        </div>
      </page-overlay>`);
      $('page-overlay').on('click', () => { $('page-overlay').remove(); });
      $('page-overlay iframe').on('click', function(e) { e.preventDefault();e.stopPropogation(); });
  });

  // Frequently Asked Questions
  $('section.faq-block ul.toggles .trigger').on('click', function(e){

      // Prevent Default
      e.preventDefault();

      // Clicked
      var $this = $(this);

      if ($this.next().hasClass('active')){
          $this.next().removeClass('active');
          $this.next().slideUp(350);
          $this.removeClass('active');
      } else {
          $this.parent().parent().find('.trigger').removeClass('active');
          $this.parent().parent().find('li .inner_answer').removeClass('active');
          $this.parent().parent().find('li .inner_answer').slideUp(350);
          $this.next().toggleClass('active');
          $this.next().slideToggle(350);
          $this.toggleClass('active');
      }

  });



  // Testimonials
  try {
    $('section.testimonials-block .testimonial-slider, #shopify-section-testimonials .testimonial-slider').slick({
        centerMode: true,
        infinite: true,
        speed: 300,
        dots: false,
        arrows: true,
        adaptiveHeight: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 12000,
        responsive: [
          {
            breakpoint: 960,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 600,
            settings: {
              centerMode: false,
              slidesToShow: 1,
              slidesToScroll: 1
            }
        }
      ]
    });

    $('.dual_column_left_carousel .single-carousel').slick({
        dots: true,
        infinite: true,
        speed: 300,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 10000
    });

    $('.carousel_dual_column .slider-column-inner').slick({
        dots: true,
        customPaging: function(slider, i) {
            return '<button class="tabbed-names"><span class="bar"></span>' + $(slider.$slides[i]).attr('title') + '</button>';
        },
        infinite: true,
        speed: 300,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 10000,
        adaptiveHeight: false
    });

    $('.carousel_single_column .slider-single-column-nav').slick({
        infinite: true,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        focusOnSelect: true,
        asNavFor: '.carousel_single_column .slider-single-column-inner',
    });

    $('.carousel_single_column .slider-single-column-inner').slick({
        dots: true,
        infinite: true,
        speed: 300,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 10000,
        adaptiveHeight: false,
        asNavFor: '.carousel_single_column .slider-single-column-nav',
    });

    $('.carousel_single_column .slider-single-column-nav').on('beforeChange', function(event,slick,slide,nextSlide) {
        $('.slider-nav-1').find('.slick-slide').removeClass('slick-current').eq(nextSlide).addClass('slick-current');
    });

   $('section.testimonials-block .testimonial-slider .review-slide, , #shopify-section-testimonials .testimonial-slider .review-slide').matchHeight();
   $('.custom-payment-methods .row .col-md-5 .portlet').matchHeight();



  } catch (e){}

//  $('.landing-page-block.content_cards .content_cards_inner .column-card').matchHeight();

   /*$('section.table-block .table-wrapper').mCustomScrollbar({
       scrollbarPosition: "outside",
       axis: "x",
       autoExpandScrollbar: true,
       theme: "dark"
   });*/

});
